import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
//@ts-ignore
import configureStore from './liveview/store/configureStore';
import { Provider } from 'react-redux';
//@ts-ignore
import LiveViewApp from './liveview/containers/app';
import { SelectedProject } from './siteAssistant';
import ApeHostNotifications from '~/_base/functions/apeHostNotifications';
import api from '~/_base/constants/api';
import logger from '~/_base/logger';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

interface Props {
  selectedProject?: SelectedProject | null;
  position: number;
}

export default function LiveView(props: Props) {
  const [open, setOpen] = useState(false);
  const { data: currentContext } = useSWR(
    api.currentContext.address,
    api.currentContext.request
  );
  const { t } = useTranslation();
    const theme = useTheme();

  useEffect(() => {
    function apeHostNotificationHandler(event: any) {
      switch (event.type) {
        case 'NoOperationNavigation':
          if ((event.uri || '').indexOf('live_view') !== -1) {
            setOpen(true);
          }
          break;
      }
    }
    ApeHostNotifications.pushNotifier(apeHostNotificationHandler);
    return () => {
      ApeHostNotifications.removeNotifier(apeHostNotificationHandler);
    };
  }, []);

  const { position } = props;

  if (currentContext?.current_user == null) {
    return <div />;
  }

  return (
    <div>
      <Button
        id="openLiveView"
        variant='contained'
        color='primary'
        size="large"
        className={`insights_position_${position}`}
        onClick={() => {
          logger.info('Live view drawer button clicked (opened)');
          setOpen(true);
        }}
      >
        {t('Live Feed')}
      </Button>

      <Drawer
        classes={{
          paper: `liveViewDrawer`,
        }}
        className="ape-live-drawer"
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          zIndex: theme.zIndex.drawer + 2,
        }}
      >
        <div id="apeLiveViewWrapper">
          <div
            className="pseudoOpenLiveViewButtonContainer"
            onClick={() => setOpen(false)}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={`pseudoBtn insights_position_${position}`}
            >
              {t('Live Feed')}
            </Button>
          </div>
          <div id="liveViewWrapper">
            <Provider store={configureStore()}>
              <LiveViewApp />
            </Provider>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
